import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className="" src="https://image.freepik.com/free-vector/oops-404-error-with-broken-robot-concept-illustration_114360-1932.jpg" alt="" />
        </div>
    );
};

export default NotFound;